export default __webpack_public_path__ + "static/media/doc.055e5f34.png";